import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Choose a new password"
      subtitle="Enter a new password for your account."
      footer={<Link to="/login" className="text-[#7A222B] font-semibold hover:underline" data-testid="back-to-signin">← Back to sign in</Link>}
    >
      {done ? (
        <div data-testid="reset-success" className="bg-[#F5EFE6] border border-[#EAE3DB] rounded-2xl p-6 text-center text-[#2D2825] font-medium">
          Password reset! Redirecting to sign in…
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && <div data-testid="reset-error" className="bg-[#FAF0F1] border border-[#D99B9F] text-[#7A222B] text-sm rounded-xl px-4 py-3">{error}</div>}
          {!token && <div className="bg-[#FAF0F1] border border-[#D99B9F] text-[#7A222B] text-sm rounded-xl px-4 py-3">Missing reset token. Please use the link from your email.</div>}
          <div>
            <label className="text-sm font-medium text-[#2D2825]">New password</label>
            <input
              type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="reset-password"
              className="mt-1.5 w-full rounded-xl border border-[#EAE3DB] bg-white px-4 py-3 text-[#2D2825] focus:outline-none focus:border-[#7A222B] focus:ring-2 focus:ring-[#7A222B]/10 transition"
              placeholder="At least 6 characters"
            />
          </div>
          <button
            type="submit" disabled={loading || !token} data-testid="reset-submit-btn"
            className="w-full flex items-center justify-center gap-2 bg-[#7A222B] hover:bg-[#5C1D24] text-white font-semibold py-3 rounded-xl transition-colors disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Reset password
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
